import React from 'react';
import { useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import useTrackAssetConfigureEvent from '../../hooks/use-track-configure-asset.js';
import { fromAssetAtom, fromAssetsAtom, fromWalletAccountAtom, isLoadingAtom, } from '../../../atoms/index.js';
const FromAsset = ({ Component, className, style, onPress }) => {
    const fromAsset = useAtomValue(fromAssetAtom);
    const fromWalletAccount = useAtomValue(fromWalletAccountAtom);
    const isLoading = useAtomValue(isLoadingAtom);
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const handlePress = useAtomCallback(async (get, set) => {
        const source = await onPress?.({
            side: 'from',
            assets: get(fromAssetsAtom),
            walletAccount: get(fromWalletAccountAtom).toString(),
        });
        if (!source)
            return;
        const { asset, walletAccount } = source;
        void trackAssetConfigureSwap();
        if (asset)
            set(fromAssetAtom, asset);
        if (walletAccount)
            set(fromWalletAccountAtom, walletAccount);
    }, [trackAssetConfigureSwap, onPress]);
    if (Component) {
        return (React.createElement(Component, { side: "from", asset: fromAsset, walletAccount: fromWalletAccount, loading: isLoading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default FromAsset;
